import React from 'react';
import PropTypes from 'prop-types';

import { Box, Stack, Tooltip, Typography } from '@mui/material';

import { boxStyle, imageStyle, fileNameStyle, filePreviewBox } from './style';

export default function FilePreview({ file, url, isImage }) {
  return (
    <Box key={`${file.name}-${file.size}`} sx={filePreviewBox}>
      <Stack spacing={2} alignItems="center">
        <Box sx={boxStyle}>
          <img
            src={url}
            alt={file.name}
            style={imageStyle(isImage)}
            onLoad={isImage ? () => URL.revokeObjectURL(url) : undefined}
          />
        </Box>
        <Tooltip title={file.name}>
          <Typography sx={fileNameStyle} variant="caption">
            {file.name}
          </Typography>
        </Tooltip>
        <Typography variant="caption" color="text.secondary">
          {(file.size / 1024).toFixed(1)} KB
        </Typography>
      </Stack>
    </Box>
  );
}

FilePreview.propTypes = {
  file: PropTypes.object,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isImage: PropTypes.bool,
};
